import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { Globals } from '../../../globals';
import * as moment from 'moment';
import { StudentsListPage } from '../students-list/students-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-students-view.html',
  templateUrl: 'students-view.html',
})
export class StudentsViewPage {
  student: any;
  //students: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public schoolServices: SchoolServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.student = this.navParams.get('student');
    this.student.created_date = moment(this.student.created_at.toDate()).format("DD/MM/YYYY HH:MM");
  }

  onBack() {
    this.navCtrl.pop();
  }

  async delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-alumno'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteStudent();
          }
        }
      ]
    });
    alert.present();
  }

  async deleteStudent() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-eliminando-alumno')
    });
    loadingPopup.present();

    //eliminar de classrooms y profesores
    await this.schoolServices.deleteStudentFromClassroomsAndTeachers(this.globals.school_uid, this.student.UID);
    //delete restaurant y de users
    await this.deleteRestaurantStudent(this.student.UID, this.student.email);

    loadingPopup.dismiss();
    this.navCtrl.setRoot(StudentsListPage);


  }



  async deleteRestaurantStudent(uid, email) {
    await this.deleteby('cashs', uid);
    await this.deleteby('customers', uid);
    await this.deleteby('delibery_note', uid);
    await this.deleteby('dish', uid);
    await this.deleteby('expenses', uid);
    await this.deleteby('historial', uid);
    await this.deleteby('income', uid);
    await this.deleteby('ingredients', uid);
    await this.deleteby('invoices', uid);
    await this.deleteby('menus', uid);
    await this.deleteby('products', uid);
    await this.deleteby('providers', uid);
    await this.deleteby('reservations', uid);
    await this.deleteby('rooms', uid);
    await this.deleteby('tables', uid);
    await this.deleteby('tickets', uid);
    await this.deleteby('variations', uid);
    await this.deleteby('tables', uid);

    await this.schoolServices.firestore.collection('restaurants').doc(uid).delete();

    await this.deletebyEmail(email);

  }

  async deleteby(collection, uid) {
    var jobskill_query = this.schoolServices.firestore.collection(collection).where('UID_RESTAURANT', '==', uid);
    jobskill_query.get().then(function (querySnapshot) {
      querySnapshot.forEach(async function (doc) {
        await doc.ref.delete();
      });
    });
  }

  async deletebyEmail(email) {
    var jobskill_query = this.schoolServices.firestore.collection('users').where('email', '==', email);
    jobskill_query.get().then(function (querySnapshot) {
      querySnapshot.forEach(async function (doc) {
        await doc.ref.delete();
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/schools/students-view/students-view.ts